import React, {useState,useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import InvoicePeriod from '../GstInvoice/InvoicePeriod/InvoicePeriod';
import {trackGstInputData} from '../GstInvoice/ClaimGstModal/mockData';
import Modal from '../../../common/Modal/Modal';
import Table from '../../../common/Table/Table';
import TableLoader from '../../../common/Table/TableLoader';
import TrackGstInput from './TrackGstInput/TrackGstInput';
import noInvoicePng from '../../../RefundRaiseRequest/assets/no-request.png';
import EmptyInvoice from '../GstInvoice/EmptyInvoice/EmptyInvoice';
import {trackSubmitCommissionInvoice} from '@ibibo/myaccount-reducer';


import { logPageLoadEvents,logOmniClick} from '@ibibo/analytics';
import {userSelector} from '@ibibo/user-reducer';
import {getCookie} from './../../../../../utils/getCookie';

const TrackGstInputCredit = () => {
  const dispatch = useDispatch();

  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [modalDataArray, setModalDataArray] = useState([]);
  const [data, setData] = useState(null);
  const [dataLoaders, setDataLoader] = useState({
    tableLoader: false,
  });
  const [gstError, setGstError] = useState({
    invalidDate: {
      flag: false,
      message: '',
    },
  });


  const userInfoSelector =  useSelector(userSelector);
 
  useEffect(()=>{
   const {userInfo={}} = userInfoSelector ||{}
   const {account_id=''} = userInfo;
   const ccdeCookie = getCookie('ccde');
   const isGCC = ccdeCookie == 'AE';
 logPageLoadEvents('reports:mysettings', {
         eVar15: `myPartner_gstSubmit|mypartner`,
         eVar67: `${account_id || ''}`,//mypartner agent id
         prop27: '/agent/gstinvoice/',
         eVar37: isGCC ?'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng':'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
       });

  },[])

  const onActionClick = (data, itemArray) => {
    setModalData(data);
    setDetailsModal(true);
    setModalDataArray(itemArray);
  };

  const getCommissionData = dateObject => {
    setSelectedDate(dateObject);
    setDataLoader({...dataLoaders, tableLoader: true});
    dispatch(
      trackSubmitCommissionInvoice(
        dateObject,
        getCommissionDataSuccessCallback,
        getCommsionBreakupErrorCallback,
      ),
    );
  };

  const getCommissionDataSuccessCallback = resp => {
    setDataLoader({...dataLoaders, tableLoader: false});
    setData(resp);
  };

  const getCommsionBreakupErrorCallback = err => {
    setData(null);
    const obj = JSON.parse(JSON.stringify(gstError));
    obj.invalidDate.message = err.message;
    obj.invalidDate.flag = true;
    setGstError({...obj});
    setDataLoader({...dataLoaders, tableLoader: false});
  };

  const resetData = () => {
    setData(null);
  };

  const closeModal = () => setDetailsModal(false);

  return (
    <React.Fragment>
      <InvoicePeriod getGstDataCaller={getCommissionData} resetData={resetData} />
      {data === null && dataLoaders?.tableLoader === false && (
        <div className="mt30">
          <EmptyInvoice
            icon={noInvoicePng}
            description={
              gstError.invalidDate.flag
                ? gstError.invalidDate.message
                : 'You haven’t generated any invoice so far! <Span>Select your Period/Month to download invoices</span>.'
            }
          />
        </div>
      )}
      {data !== null && (
        <Table
          data={trackGstInputData}
          onActionBtnClick={onActionClick}
          tableData={{month_wise_breakup: data?.monthwise_breakup_data}}
        />
      )}
      {dataLoaders?.tableLoader && <TableLoader />}
      {detailsModal && (
        <Modal closeBtn onClose={closeModal}>
          <TrackGstInput data={modalData} dataArray={modalDataArray} />
        </Modal>
      )}
    </React.Fragment>
  );
};

export default TrackGstInputCredit;
